import { ModuleTile } from './ModuleTile';

export const ModuleGrid = ({ modules, favorites, onToggleFavorite, onOpenModule }) => {
  if (!modules || modules.length === 0) {
    return (
      <div className="empty-state">
        <p>No modules available</p>
      </div>
    );
  }

  return (
    <div className="module-grid">
      {modules.map(module => (
        <ModuleTile
          key={module.id}
          module={module}
          isFavorite={favorites.includes(module.id)}
          onToggleFavorite={onToggleFavorite}
          onOpen={onOpenModule}
        />
      ))}
    </div>
  );
};

export default ModuleGrid;
